import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Environment } from 'src/environments/environment.model';

import { GetSilosResponse, Silo } from '../models/barn.model';

@Injectable({
  providedIn: 'root',
})
export class SiloService {
  private readonly baseUrl = `${this.env.APIM_BASE_URL}/silo-v2-service/silo`;

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: Environment,
  ) {}

  getSilos(): Observable<Silo[] | HttpErrorResponse> {
    return this.http.get<GetSilosResponse>(`${this.baseUrl}`).pipe(
      map((response: GetSilosResponse) => response.silos),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<Silo[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }
}
